package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class ArticleSortEnum(
    val sortId: String,
) {
    AUTO_BY_NAME(
        sortId = "0",
    ),
    AUTO_BY_NUMBER(
        sortId = "1"
    ),
    MANUAL(
        sortId = "2"
    );

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                AUTO_BY_NAME -> strings.sortingAutoByName
                AUTO_BY_NUMBER -> strings.sortingAutoByNumber
                MANUAL -> strings.sortingManual
            }
        }

}